import { render } from "./ButtonsEditor.vue?vue&type=template&id=7ca1ee66&scoped=true"
import script from "./ButtonsEditor.vue?vue&type=script&lang=js"
export * from "./ButtonsEditor.vue?vue&type=script&lang=js"

import "./ButtonsEditor.vue?vue&type=style&index=0&id=7ca1ee66&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\ft\\Coding\\GT Designer\\gtdesigner\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ca1ee66"]])

export default __exports__